import { isTokenExpired, refreshToken } from "../services/authServices";
import { useEffect } from "react";

const useTokenRefresh = () => {
  useEffect(() => {
    const isPublicGuidebookRoute = () => {
      return (
        /^\/guidebooks\/share\/[^/]+$/.test(window.location.pathname) ||
        /^\/guidebooks\/public\/[^/]+$/.test(window.location.pathname)
      );
    };

    const intervalId = setInterval(async () => {
      if (isPublicGuidebookRoute()) {
        return;
      }

      const token = localStorage.getItem("token");
      const storedRefreshToken = localStorage.getItem("refreshToken");

      // Check if both token and refresh token are missing
      if (!token && !storedRefreshToken) {
        console.log(
          "Both token and refresh token are missing, redirecting to login"
        );
        window.location.href = "/login";
        return;
      }

      // Check if token exists but is expired
      if (token && isTokenExpired(token)) {
        // Only try to refresh if refresh token exists
        if (storedRefreshToken) {
          try {
            await refreshToken();
          } catch (error) {
            console.log("Failed to refresh token automatically", error);
            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            window.location.href = "/login";
          }
        } else {
          // If token is expired but no refresh token, log out
          console.log(
            "Token expired and no refresh token found, redirecting to login"
          );
          localStorage.removeItem("token");
          window.location.href = "/login";
        }
      }
    }, 5 * 60 * 1000); // Check every 5 minutes

    return () => clearInterval(intervalId);
  }, []);
};

export default useTokenRefresh;
